import { Instagram, Mail } from "lucide-react";
import { NAV_LINKS } from "@/data/content";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      style={{
        backgroundColor: "var(--bg)",
        borderTop: "1px solid var(--border-c)",
      }}
    >
      <div className="container-fx py-16">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-baseline gap-2">
              <span
                className="font-serif"
                style={{
                  fontSize: "2rem",
                  letterSpacing: "0.12em",
                  color: "var(--text)",
                }}
              >
                FORTE
              </span>
              <span
                className="font-serif"
                style={{
                  fontStyle: "italic",
                  color: "var(--muted)",
                  fontSize: "1rem",
                }}
              >
                By Ryann
              </span>
            </div>
            <p
              className="mt-4 max-w-sm"
              style={{ color: "var(--muted)", fontSize: "0.92rem", lineHeight: 1.7 }}
            >
              Athletic Pilates, mobility, and progressive strength training —
              intentionally programmed for continual, intelligent progression.
            </p>
          </div>

          <div>
            <p className="eyebrow" style={{ color: "var(--muted)" }}>
              Explore
            </p>
            <div className="mt-4 flex flex-col gap-2">
              {NAV_LINKS.map((l) => (
                <a
                  key={l.id}
                  href={l.href}
                  className="text-left"
                  style={{
                    color: "var(--text-2)",
                    fontSize: "0.9rem",
                    transition: "color 0.2s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.color = "var(--bronze)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.color = "var(--text-2)")
                  }
                >
                  {l.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <p className="eyebrow" style={{ color: "var(--muted)" }}>
              Connect
            </p>
            <div className="mt-4 flex flex-col gap-3">
              <a
                href="https://www.instagram.com/fortebyryann/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2"
                style={{ color: "var(--text-2)", fontSize: "0.9rem" }}
              >
                <Instagram size={16} style={{ color: "var(--bronze)" }} />
                Instagram
              </a>
              <a
                href="/#contact"
                className="flex items-center gap-2 text-left"
                style={{ color: "var(--text-2)", fontSize: "0.9rem" }}
              >
                <Mail size={16} style={{ color: "var(--bronze)" }} />
                Get in touch
              </a>
              <a
                href="/digital-studio"
                className="btn-fx btn-outline mt-3"
                style={{ height: 42, alignSelf: "flex-start" }}
              >
                Explore Digital Studio
              </a>
            </div>
          </div>
        </div>

        <div
          className="mt-12 flex flex-col items-center justify-between gap-3 pt-7 sm:flex-row"
          style={{ borderTop: "1px solid var(--border-c)" }}
        >
          <span style={{ color: "var(--muted-2)", fontSize: "0.78rem" }}>
            &copy; {new Date().getFullYear()} Forte by Ryann. All rights reserved.
          </span>
          <span
            style={{
              color: "var(--muted-2)",
              fontSize: "0.72rem",
              letterSpacing: "0.14em",
              textTransform: "uppercase",
            }}
          >
            Move with intention
          </span>
        </div>
      </div>
    </footer>
  );
};
